export default "__VITE_ASSET__BAtb9iYw__"